import { gql } from '@apollo/client';

export const SEARCH_PASSENGERS = gql`
  query SearchPassengers($email: String!) {
    searchPassengers(email: $email) {
      id
      email
      phone
    }
  }
`;

export const SEARCH_DRIVERS = gql`
  query SearchDrivers($text: String, $drivingCompanyId: String) {
    searchDrivers(text: $text, drivingCompanyId: $drivingCompanyId) {
      id
      email
      name
      phone
    }
  }
`;

export const FETCH_ALL_DRIVERS = gql`
  query FetchAllDrivers {
    drivers {
      id
      volcanoDriverId
      name
      phone
      email
      inPrisma
      inVolcano
      hasLoginCredentials
    }
  }
`;

export const FETCH_ALL_DRIVERS_FROM_DRIVING_COMPANY = gql`
  query FetchAllDrivers($drivingCompanyId: ID!) {
    driversByDrivingCompany(drivingCompanyId: $drivingCompanyId) {
      id
      volcanoDriverId
      name
      phone
      email
      inPrisma
      inVolcano
      hasLoginCredentials
    }
  }
`;

export const FETCH_ALL_SERVICES = gql`
  query Services($departureDateMin: String, $departureDateMax: String) {
    services(
      departureDateMin: $departureDateMin
      departureDateMax: $departureDateMax
    ) {
      id
      volcanoServiceId
      budgetReadableId
      description
      status
      reference
      client {
        id
        email
        name
        volcanoClientId
      }
      itineraryDescription
      numOfPassengers
      departure {
        date
        time
        address
      }
      arrival {
        date
        time
        address
      }
    }
  }
`;

export const FETCH_SERVICE_DRIVERS_INFO = gql`
  query ServiceDriversInfo($id: ID!) {
    service(id: $id) {
      id
      volcanoServiceId
      budgetReadableId
      drivingCompany {
        id
      }
      driver {
        id
        volcanoDriverId
        received
        name
        phone
        email
        type
        status
      }
      alternateDriver {
        id
        volcanoDriverId
        received
        name
        phone
        email
        type
        status
      }
    }
  }
`;

export const FETCH_SERVICE_PASSENGERS_INFO = gql`
  query ServicePassengersInfo($id: ID!) {
    service(id: $id) {
      id
      volcanoServiceId
      passengers {
        id
        phone
        name
        email
      }
    }
  }
`;

export const FETCH_USER_PASSENGERS = gql`
  query UserPassengers($id: ID!) {
    passengersForUser(id: $id) {
      id
      name
      phone
      email
    }
  }
`;

export const FETCH_SERVICE_DRIVERS_VEHICLE_INFO = gql`
  query ServiceDriverInfo($id: ID!) {
    service(id: $id) {
      id
      budgetReadableId
      volcanoServiceId
      arrival {
        date
        time
      }
      client {
        name
        id
      }
      driver {
        id
        received
        name
        phone
        alternatePhone
        email
        type
        status
        inPrisma
        inVolcano
        location {
          latitude
          longitude
        }
      }
      alternateDriver {
        id
        received
        name
        phone
        alternatePhone
        email
        type
        status
        inPrisma
        inVolcano
        location {
          latitude
          longitude
        }
      }
      drivingCompany {
        id
        email
        volcanoId
        name
        phone
      }
      vehicle {
        id
        location {
          latitude
          longitude
        }
        type
        typeID
        typeDescription
        status
        licensePlate
        brand
        model
      }
    }
  }
`;

export const FETCH_SERVICES_BY_CLIENT = gql`
  query ServicesByClient(
    $id: ID!
    $departureDateMin: String
    $departureDateMax: String
  ) {
    client(
      id: $id
      departureDateMin: $departureDateMin
      departureDateMax: $departureDateMax
    ) {
      id
      services {
        id
        reference
        budgetReadableId
        volcanoServiceId
        description
        type
        typeId
        status
        itineraryDescription
        numOfPassengers
        volcanoServiceId
        departure {
          date
          time
        }
        numOfPassengers
        passengers {
          id
          email
          phone
          name
        }
        arrival {
          date
          time
        }
        client {
          email
          id
          volcanoClientId
        }
      }
    }
  }
`;
